// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconFolderPlus = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.401 8.417v9.124a2.4 2.4 0 0 0 2.4 2.4H19.2a2.4 2.4 0 0 0 2.4-2.4V8.213a1.2 1.2 0 0 0-1.2-1.2h-8.316L9.319 4.058H3.6a1.2 1.2 0 0 0-1.2 1.2l.001 3.158z',
      fill: 'current'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12 16.8v-3.394m0 0v-3.394m0 3.394H8.606m3.394 0h3.394M2.401 17.541V5.259a1.2 1.2 0 0 1 1.2-1.2h5.718l2.765 2.953H20.4a1.2 1.2 0 0 1 1.2 1.2v9.33a2.4 2.4 0 0 1-2.4 2.4H4.8a2.4 2.4 0 0 1-2.4-2.401z',
      stroke: 'current',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );

export { IconFolderPlus };
